module.exports = __webpack_public_path__ + "static/classhook-browse-915f68c676903d66273743b89fbc36ac.jpg";